<div class="card stickyCard">
  <div class="card-header-white header-underline">
    <strong>
      <h6 class="white-header-text">{{'ADD_NEW_DEVICE' |translate}}</h6>
    </strong>
    <span class="float-right cursorPointer" (click)="closeAddFormEvent.emit()">
      <span class="fa-light fa-xmark" style="margin-right: 15px; position: relative; top: -12px"></span>
    </span>
  </div>

  <div class="card-body-white">
    @if (addDevFormError$.value) {
      <div class="alert alert-danger">
        {{ addDevFormError$.value | translate }}
      </div>
    }

    @if (addDevFormInfo$.value) {
      <div class="alert alert-info">
        {{ addDevFormInfo$.value | translate }}
      </div>
    }

    <div>
      <app-add-device-form
        [locations]="locations"
        [errorMsg$]="addDevFormError$"
        [informationMsg$]="addDevFormInfo$"
        (savedEvent)="deviceAddedEvent.emit($event)"
      ></app-add-device-form>
    </div>
  </div>
</div>
